/**
 * @generated SignedSource<<5842725b061d89ce0cec151e5c715406>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetEstimatedValueRange_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item" | "useShowPricingGuidance_item">;
  readonly " $fragmentType": "useGetEstimatedValueRange_item";
};
export type useGetEstimatedValueRange_item$key = {
  readonly " $data"?: useGetEstimatedValueRange_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetEstimatedValueRange_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetEstimatedValueRange_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "114f0ebe1ec4fdb7f5e5bc109f5b2ef7";

export default node;
